"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logAmplitudeEvent = logAmplitudeEvent;
exports.initializeAmplitude = initializeAmplitude;
exports.getAmplitudeRouteEventId = getAmplitudeRouteEventId;
exports.getPeriscopeOpenedEvent = getPeriscopeOpenedEvent;
const sonar_ts_constants_1 = require("@sonar-software/sonar-ts-constants");
const lib_1 = require("../core/lib.js");
const _types_1 = require("./@types/index.js");
const analytics_browser_1 = require("@amplitude/analytics-browser");
function isAmplitudeAnalyticsEnabled() {
    const { amplitude_api_key } = window.sonar;
    // eslint-disable-next-line camelcase
    return Boolean(amplitude_api_key) && (0, lib_1.isAnalyticsEnabled)();
}
function logAmplitudeEvent(event) {
    try {
        if (isAmplitudeAnalyticsEnabled()) {
            const { id, data } = event;
            (0, analytics_browser_1.track)(id, data);
        }
    }
    catch (ex) {
        console.log('error logging to amplitude:', ex);
    }
}
function initializeAmplitude(data) {
    try {
        if (isAmplitudeAnalyticsEnabled()) {
            const { amplitude_api_key } = window.sonar;
            const { customer, email, orgCount, userCount } = data;
            const identity = new analytics_browser_1.Identify()
                .set('customer', customer)
                .set('orgCount', orgCount)
                .set('userCount', userCount);
            (0, analytics_browser_1.init)(amplitude_api_key, email, { includeReferrer: true });
            (0, analytics_browser_1.identify)(identity);
        }
    }
    catch (ex) {
        console.log('error initializing amplitude:', ex);
    }
}
function getAmplitudeRouteEventId(route) {
    switch (route) {
        case sonar_ts_constants_1.FULL_ROUTES.DASHBOARD:
            return _types_1.AMPLITUDE_EVENT.DASHBOARD_CLICKED;
        case sonar_ts_constants_1.FULL_ROUTES.INITIATIVES:
            return _types_1.AMPLITUDE_EVENT.INITIATIVE_DASHBOARD_VIEWED;
        case sonar_ts_constants_1.FULL_ROUTES.ISSUES:
            return _types_1.AMPLITUDE_EVENT.ISSUES_VIEWED;
        case sonar_ts_constants_1.FULL_ROUTES.SETTINGS:
            return _types_1.AMPLITUDE_EVENT.SETTINGS_VIEWED;
        case sonar_ts_constants_1.FULL_ROUTES.TAGS:
            return _types_1.AMPLITUDE_EVENT.TAGS_VIEWED;
        case sonar_ts_constants_1.FULL_ROUTES.TIMELINE:
            return _types_1.AMPLITUDE_EVENT.TIMELINE_VIEWED;
        default:
            return null;
    }
}
function getPeriscopeOpenedEvent(from, type) {
    return {
        data: {
            from,
            type
        },
        id: _types_1.AMPLITUDE_EVENT.PERISCOPE_OPENED
    };
}
//# sourceMappingURL=lib.js.map